import React, {Component} from 'react'
import WPEngineFAQs from './faqs/wpengine'
import GenericFAQs from './faqs/generic'
import SavviiFAQs from './faqs/savvii'
import CloudwaysFAQs from './faqs/cloudways'
import WeFosterFAQs from './faqs/wefoster'
import SiteGroundFAQs from './faqs/siteground'
import HostGatorFAQs from './faqs/hostgator'
import FlywheelFAQs from './faqs/flywheel'
import GoDaddyFAQs from './faqs/godaddy'
import WPServeurFAQs from './faqs/wpserveur'
import BluehostFAQs from './faqs/bluehost'
import HostingerFAQs from './faqs/hostinger'
import CPanelFAQs from './faqs/cpanel'
import JaguarPCFAQs from './faqs/jaguarpc'
import GuruCoUKFAQs from './faqs/gurucouk'
import InterserverFAQs from './faqs/interserver'
import PantheonFAQs from './faqs/pantheon'
import DreamHostFAQs from './faqs/dreamhost'
import SandboxFAQs from './faqs/sandbox'
import PagelyFAQs from './faqs/pagely'
import A2HostingFAQs from './faqs/a2hosting'
import InMotionHostingFAQs from './faqs/inmotion'
import PressableFAQs from './faqs/pressable'
import KinstaFAQs from './faqs/kinsta'
import NexcessFAQs from './faqs/nexcess'
import ElementorFAQs from './faqs/elementor'

class FAQs extends Component{
	render(){
		const { formType, bvKeyMigrationEnabled } = this.props
		switch (formType){
		case "WP Engine": return <WPEngineFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Savvii": return <SavviiFAQs />
		case "Cloudways": return <CloudwaysFAQs />
		case "WeFoster": return <WeFosterFAQs />
		case "Siteground": return <SiteGroundFAQs />
		case "HostGator": return <HostGatorFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Flywheel": return <FlywheelFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "GoDaddy": return <GoDaddyFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "WP Serveur": return <WPServeurFAQs />
		case "Nexcess": return <NexcessFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Bluehost": return <BluehostFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Hostinger": return <HostingerFAQs />
		case "Generic": return <GenericFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "CPanel": return <CPanelFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "InterServer": return <InterserverFAQs />
		case "JaguarPC": return <JaguarPCFAQs />
		case "Guru UK": return <GuruCoUKFAQs />
		case "Pantheon": return <PantheonFAQs />
		case "DreamHost": return <DreamHostFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Sandbox": return <SandboxFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Pagely": return <PagelyFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "A2 Hosting": return <A2HostingFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "InMotion Hosting": return <InMotionHostingFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Pressable": return <PressableFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Kinsta": return <KinstaFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		case "Elementor": return <ElementorFAQs bvKeyMigrationEnabled={bvKeyMigrationEnabled} />
		default: return <div></div>
		}
	}
}

export default FAQs
